import React from 'react';

export default function ContactHeader(props) {
    const { className, isHomePage, noTitles } = props;

    let classNames = 'contact-header justify-center';

    if (typeof className !== 'undefined') {
        classNames = `${classNames} ${className}`;
    }

    return (
        <article role="contact" className={classNames}>
            <Title isHomePage={isHomePage} noTitles={noTitles} />

            <div className="grid-center-noGutter content-maxWidth">
                <div className="col-11">

                    <div className="grid contact-header--details">
                        <div className="col-5_xs-12_sm-12">
                            <i className="icon-location-pin highlight" />
                            <span className="list-title">1039 Gerrard Street E., Toronto ON, M4M 1Z6</span>
                        </div>
                        <div className="col-2_xs-12_sm-12">
                            <i className="icon-phone highlight" />
                            <span className="list-title">
                                <a
                                    className="link"
                                    href="tel:+1-416-551-7326"
                                >+1 (416) 551-7326</a>
                            </span>
                        </div>
                        <div className="col-5_xs-12_sm-12">
                            <i className="icon-envelope-open highlight" />
                            <span className="list-title">
                                <a
                                    className="link"
                                    href="mailto:frontdesk@pursuitintegrativehealth.com"
                                >frontdesk@pursuitintegrativehealth.com</a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    )
}

const Title = (props) => {
    const { isHomePage, noTitles } = props;

    if (typeof noTitles !== 'undefined' && noTitles === true) {
        return null;
    }

    if (isHomePage === true) {
        return (
            <article>
                <div className="content-subTitle">We'd Like You To Get In Touch With Us</div>
                <h2 className="content-mainTitle minor-margin--bottom">Our Contact</h2>
            </article>
        )
    }

    return (
        <h2 className="content-title minor-margin--bottom">Our Contact</h2>
    )
}
